import { useContext } from "react";
import { ConfiguracoesContext } from "../../../contexts/Configuracoes/ConfiguracoesContext";
import Titulo from "../../Modal/ModaisConfigsPrimeiroAcesso/Titulo/Titulo";
import { ContainerPoliticaDeFreteContainer } from "./styles";
import "react-quill/dist/quill.snow.css";
import { useTheme } from "../../../contexts/Theme/ThemeContext";
import ReactQuill from "react-quill";

interface PoliticaDeFreteProps {
  configIn: "empresa" | "configuracoes";
}

export const PoliticaDeFrete: React.FC<PoliticaDeFreteProps> = ({
  configIn,
}) => {
  const { politica_de_frete, setPolitica_de_frete } = useContext(
    ConfiguracoesContext
  );

  const { theme } = useTheme();

  return (
    <>
      <ContainerPoliticaDeFreteContainer configIn={configIn} theme={theme}>
        {configIn === "empresa" && (
          <Titulo
            titulo="Política De Frete"
            subtitulo={"Configure seu catálogo"}
          />
        )}
        <div className="texto fonteTexto">
          Informe para seu cliente as condições de envio dos pedidos: prazos,
          custos, formas de entrega e demais orientações importantes.
        </div>
        <div className="containerQuill">
          <ReactQuill
            className="quill-editor"
            formats={["bold", "italic", "underline", "list"]}
            value={politica_de_frete}
            onChange={(newValue) => {
              setPolitica_de_frete(newValue);
            }}
          ></ReactQuill>
        </div>
      </ContainerPoliticaDeFreteContainer>
    </>
  );
};
